export default __webpack_public_path__ + "static/media/crosshairs.39734378.svg";